import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { closeYodleeOnboarding, resetYodleeOnboarding, selectProvider, attemptProviderMFA } from "../../actions/yodlee";
import { RESET_PLAID_ONBOARDING } from "../../actions/financial-data";
var initialState = {};
export default (function (CHANGE_TYPE) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case CHANGE_TYPE:
        {
          var _action$payload = action.payload,
              key = _action$payload.key,
              value = _action$payload.value;
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, value));
        }
      // Form state is cleared when:
      // - onboarding is explicitly reset
      // - when a new provider is selected
      // - we successfully attempt MFA
      // The last case is necessary for providers that have a two-part MFA process
      // For example, the first step might be entering their phone number and the
      // second step might be entering the security code sent to that phone number.
      // For the second step, some providers send an input that has the exact same
      // key as the first step, resulting in users seeing the new input already
      // populated with data they had entered in the first step. By resetting the form
      // data after a successful request to send MFA data, we fix this issue.

      case attemptProviderMFA.SUCCESS_TYPE:
      case closeYodleeOnboarding.getType():
      case resetYodleeOnboarding.getType():
      case RESET_PLAID_ONBOARDING:
      case selectProvider.getType():
        return initialState;

      default:
        return state;
    }
  };
});